import { useQuery } from "@tanstack/react-query";
import { fetchPackages, packagesQueryKey, type PackageList } from "./packages.api";

/**
 * Los paquetes públicos.
 *
 * La política de reintentos vive en el `QueryClient` (`app/providers.tsx`)
 * y no aquí: así una prueba puede apagarla y la pantalla no se queda en
 * "cargando" mientras reintenta contra un backend que todavía no existe.
 *
 * Y no existe: cuando esto se escribió, `backend/src/modules/` tenía
 * `auth`, `health` y `product`. `/api/packages` responde 404 hasta que el
 * módulo aterrice, así que el estado de error de esta pantalla no es un
 * caso raro — es lo que se ve hoy al entrar.
 */
export function usePackages() {
  return useQuery<PackageList>({
    queryKey: packagesQueryKey,
    queryFn: fetchPackages,
  });
}
